import type { TopUpBonusTier } from '../services/brandService';

/**
 * Preview the promotional StoredValue bonus a recharge of `amount` € would grant,
 * mirroring the backend `Brand.ResolveTopUpBonus`: the bonus of the highest tier whose
 * threshold is ≤ the amount, or 0 when no tier matches (or none are configured). Kept in
 * sync with the server so the amount screen shows the same figure that will be credited.
 */
export function resolveTopUpBonus(amount: number, tiers?: TopUpBonusTier[]): number {
    if (!tiers || tiers.length === 0) return 0;

    return tiers
        .filter((tier) => tier.threshold <= amount)
        .reduce((best, tier) => (tier.threshold > best.threshold ? tier : best), { threshold: -1, bonus: 0 })
        .bonus;
}
